import { inject, observer } from 'mobx-react';
import * as React from 'react';
import SsoStore from '../stores/SsoStore';

interface LoggedInProps {
  ssoStore?: SsoStore;
  children: React.ReactNode;
  showForDealer?: boolean;
}

@observer
class LoggedIn extends React.Component<LoggedInProps> {
  public render() {
    const { ssoStore, showForDealer } = this.props;
    if ((ssoStore.loggedIn && !showForDealer) || (ssoStore.isDealer && showForDealer)) {
      return <>{this.props.children}</>;
    }
    return null;
  }
}

export default inject('ssoStore')(LoggedIn);
